//import { initPageTransitions } from "../barba/transitions";
import { initScript } from "./initScript";

export function initApp() {
  gsap.registerPlugin(
    ScrollTrigger,
    CustomEase,
    Draggable,
    InertiaPlugin,
    Flip,
  );
  ScrollTrigger.config({
    ignoreMobileResize: true,
  });

  if (ScrollTrigger.isTouch) {
    ScrollTrigger.config({
      ignoreMobileResize: true,
    });

    ScrollTrigger.normalizeScroll(true);
  }

  document.fonts.ready.then(() => {
    if (typeof SplitText !== "undefined") {
      gsap.registerPlugin(SplitText);
    }

    // initPageTransitions();
    initScript();
  });
}
